import { apiClient } from './apiClient'

export interface TaxCategoryResponse {
  id: string
  name: string
  active: boolean
}

export const taxApi = {
  getActiveCategories: () => apiClient.get<TaxCategoryResponse[]>('/tax-categories'),
}
